var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50ZM11.2882 50C11.2882 71.38 28.62 88.7118 50 88.7118C71.38 88.7118 88.7118 71.38 88.7118 50C88.7118 28.62 71.38 11.2882 50 11.2882C28.62 11.2882 11.2882 28.62 11.2882 50Z",
    fill: "#FFE20D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 51.6004L43.2 62.8004L68 38.0004",
    stroke: "#FFE20D",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.37aa5ef34769e765d1cc26f97b1df9f7.svg";
export { ForwardRef as ReactComponent };